export default function StatusBadge({ status, variant }) {
  const map = {
    active: "badge-success",
    healthy: "badge-success",
    delivered: "badge-success",
    completed: "badge-success",
    verified: "badge-success",
    approved: "badge-success",
    open: "badge-info",
    pending: "badge-warning",
    degraded: "badge-warning",
    manual_review: "badge-warning",
    draft: "badge-muted",
    closed: "badge-muted",
    expired: "badge-muted",
    suspended: "badge-error",
    failed: "badge-error",
    dead_letter: "badge-error",
    rejected: "badge-error",
    disabled: "badge-error",
    down: "badge-error",
    rolled_back: "badge-error",
    terminated: "badge-muted",
    reviewed: "badge-info",
    resolved: "badge-success",
    paid: "badge-gold",
    BET: "badge-error",
    WIN: "badge-success",
    ROLLBACK: "badge-warning",
    REFUND: "badge-info",
    BONUS: "badge-gold",
    ADJUSTMENT: "badge-muted",
    DEPOSIT: "badge-info",
    WITHDRAWAL: "badge-warning",
    BALANCE_CHANGE: "badge-info",
    topup: "badge-info",
    adjust: "badge-warning",
    bet: "badge-error",
    win: "badge-success",
    refund: "badge-gold",
    rollback: "badge-warning",
  };
  const cls = variant ? `badge ${variant}` : `badge ${map[status] || "badge-muted"}`;
  return <span className={cls} data-testid={`status-${status}`}>{String(status).replace(/_/g, " ")}</span>;
}
